import React from 'react'
import { useIntl } from 'react-intl';
import Hero from '../components/Hero';

export type ComplaintsAppealsPageProps = {};

const ComplaintsAppealsPage: React.FC<ComplaintsAppealsPageProps> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={'/img/custcomplaint.png'}
        heading={
          intl.formatMessage({
            id: 'complaints-appeals'
          })
        }
      />
      <div className="content gap-4">
        <h2 className="text-2xl text-secondary font-bold">
          {
            intl.formatMessage({
              id: 'complaints-appeals'
            })
          }
        </h2>
        <p className="nested-links" dangerouslySetInnerHTML={{__html: intl.formatMessage({id: 'comp-appeal_1'})}}></p>
        <p className="nested-links" dangerouslySetInnerHTML={{__html: intl.formatMessage({id: 'comp-appeal_2'})}}></p>
        <div className="w-full flex flex-col md:flex-row items-center">
          <div className="w-full md:w-2/3 flex flex-col my-4">
            <a href="/pdf/complaints-appeals/MCB-DQA-026 Solicitud de quejas o apelaciones.docx" className="w-full flex flex-row items-center mb-4" target="_blank">
              <img src="/icons/cloudload.svg" alt="" className="w-14 mr-4" />
              <p className="text-xl font-semibold">
                {intl.formatMessage({
                  id: 'comp-appeal_3'
                })}
              </p>
            </a>
            <a href="/pdf/complaints-appeals/MCB-DQA-090 Diagrama de flujo para el tratamiento de quejas y apelaciones.pdf" className="w-full flex flex-row items-center mb-4" target="_blank">
              <img src="/icons/eyeglass.svg" alt="" className="w-14 mr-4" />
              <p className="text-xl font-semibold">
                {intl.formatMessage({
                  id: 'comp-appeal_4'
                })}
              </p>
            </a>
          </div>
          <div className="w-full md:w-1/3 flex items-center justify-center my-4">
            <img src="/icons/pplchat.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ComplaintsAppealsPage;